// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611031918/js/" + chunkId + "." + {"44":"cd0ccd9e","225":"d418828f","481":"460cd1dd","486":"cbd17354","770":"e34c8882"}[chunkId] + ".0.25152327312945844.chunk.js";
};